import { ExpandedRowVM } from './buildExpandedRowVM';
import { reorderByOperationIds } from './reorderRowCards';

/**
 * 停車地を並べ替えたときの、展開行の VM。
 *
 * 停車地は arrivalAt 順に組み立てる (buildOperationPlaces)。並べ替えの保存が返るまで
 * 時刻は古いままなので、カード列を並べ替えても停車地は元の順に戻る。
 * 展開パネル・地図の番号マーカー・共通配送先はこの VM を読むので、ここで並べ替える。
 *
 * 番号 (seriesIndex) は回転をまたいだ通し番号なので、行の元の先頭番号から見えている順に振り直す。
 * 時刻・作業時間はその停車地の値のまま（計算し直すのは保存 = 自動配車の仕事）。
 */
export function reorderExpandedStopsByOperationIds(
  vm: ExpandedRowVM,
  orderedOperationIds: readonly number[],
): ExpandedRowVM {
  const stops = reorderByOperationIds(vm.stops, (stop) => stop.operationIds, orderedOperationIds);
  if (stops === vm.stops) return vm;

  const firstSeriesIndex = Math.min(...vm.stops.map((stop) => stop.seriesIndex));
  return {
    ...vm,
    stops: stops.map((stop, index) => ({ ...stop, seriesIndex: firstSeriesIndex + index })),
  };
}
